import type { FeatureNavNode, StoredAuthUser } from "@nasam/core";

/**
 * The label a nav node shows in the shell -- the drawer and the breadcrumb
 * share it, so a page's breadcrumb always reads like the tabs that led there.
 *
 * Some labels depend on who is signed in. These are presentation-only
 * overrides keyed off the node id, not variants of the static nav tree, so
 * the dynamic rail/drawer build stays untouched:
 * - a client account sees the organization group as "Company management";
 * - a staff (tenant employee) account sees "User management" as "Driver
 *   management".
 */
export function navNodeTitle(
  node: FeatureNavNode,
  t: (key: string) => string,
  user?: Pick<StoredAuthUser, "userType"> | null,
): string {
  if (node.id === "organization" && user?.userType === "customer") {
    return t("companies:moduleTitleClient");
  }
  if (node.id === "user-management" && user?.userType === "staff") {
    return t("userManagement:moduleTitleStaff");
  }
  return t(
    node.titleKey.includes(":") ? node.titleKey : `navigation:${node.titleKey}`,
  );
}
